const translations = {
    en: {
        save: "Save",
        selectLanguage: "Select a language",
        eventTickets: "Event tickets",
        visitAsiaExpo: "Visit to ASIAEXPO 2025",
        ticketOnePerson: "Ticket for one person to attend the Sirius Arena Olympic Park Congress",
        organizer: "Organizer",
        visitor: "Visitor",
        promo: "Promo",
        media: "The media",
        speaker: "Speaker",
        exhibitor: "The Exhibitor",
        endOfList: "End of the list",
        tickets: "Tickets",
        users: "Users",
        accessRights: "Access rights",
        menu: "Menu",
        search: "Search",
        searchPlaceholder: "Enter your search query",
        entrance: "Entrance",
        shareApp: "Share the app",
        logOut: "Log out of your account",
        ticketing: "Making an order",
        personalData: "Personal data",
        name: "Name",
        required: "Required to fill in",
        surname: "Surname",
        organizationName: "Name of the organization",
        position: "Who are you / Position",
        notSpecified: "Not specified",
        mobilePhone: "Mobile phone",
        email: "Email",
        confirmOrder: "Confirm the order",
        readyForAccreditation: "Ready for accreditation",
        moreDetailed: "More detailed",
        awaitingPayment: "Awaiting payment",
        accreditedBadgeIssued: "Accredited, badge issued",
        issueBadge: "Issue a badge",
        change: "To change",
        repeatOrder: "Repeat the order",
        orderCost: "The cost of the order",
        scanning: "Scanning",
        myLocation: "My location",
        location:"Location",
        scanBadge: "Scan the badge",
        hoverQrCode: "Hover over the QR code to read it",
        requestPermission: "Request permission",
        stopScanning: "Stop scanning",
        chooseEventLocation: "Choose an event and your location",
        cancel: "Cancel",
        startingRegistration: "Starting the registration process",
        creatingOrder: "Creating an order",
        orderCreated: "The order was successfully created",
        choosePaymentMethod: "Choose a payment method",
        promoCode: "Promo code",
        accuracy:"accuracy",
        apply: "Apply",
        accountDetailsOrQrCode: "According to the account details or QR code, the invoice will be sent after the order is created by e-mail",
        bankPagePayment: "On the bank's page with a card or using a QR code",
        onlinePayment: "Online payment",
        usedCashPayment: "Used cash payment to a bank account",
        back: "Back",
        agents: "Counterparties",
        events: "Events",
        createBtn: "Create",
        filter: 'Filter',
        country: "Country",
        segments: "Segments",
        areaActivity: "Area activity",
        nameTable: "Name",
        counterStatus: "Counterparty Status",
        exhibition: "Exhibition",
        lastEvent: "Date of the last event",
        creatingCounter: 'Creating a counterparty',
        legalEntity: "Legal entity",
        naturalPerson: "Natural person",
        aboutCounterparty: 'About the counterparty',
        contactInformation: 'Contact information', // Контактная информация
        segmentation: 'Segmentation', // Сегментация
        edit: 'Edit', // Редактировать
        createEvent: 'Create event', // Создать событие
        ogrn: 'OGRN', // ОГРН
        inn: 'INN', // ИНН
        kpp: 'KPP', // КПП
        supervisorFullName: 'Supervisor\'s full name', // ФИО Руководителя
        firstName: 'First name', // Имя
        lastName: 'Last name', // Фамилия
        phone: 'Phone', // Телефон
        region: 'Region', // Регион
        locality: 'Locality', // Населенный пункт
        postalCode: 'Postal code', // Индекс
        address: 'Address', // Адрес (необязательно)
        additionalAddressInfo: 'Additional address information', // Доп. информация по адресу
        contactPerson: 'Contact person', // Контактное лицо
        website: 'Website', // Сайт
        socialNetworks: 'Social networks', // Соц-сети
        activityDirection: 'Activity direction', // Направление деятельности
        manager: 'Manager', // Менеджер
        agriculturalSector: 'Agricultural sector', // Отрасль СХ
        administrator: 'Administrator', // Администратор
        start: 'Start', // Начало
        duration: 'Duration', // Длительность
        person: 'Person', // Человек
        eventType: 'Communication method', // Тип события
        meetingPlace: 'Meeting place', // Место встречи
        additionalInformation: 'Additional information', // Дополнительная информация
        description: 'Description',
        create: 'Create ', // Создать
        dateAndTime: 'Date and time', // Дата и время
        status: 'Status', // Состояние
        eventStatus: 'Event status',
        eventOutcome: 'Event outcome',
        content: 'Content', // Содержание
        loading: 'Loading...', // Загрузка...
        date: 'Date', // Дата
        time: 'Time', // Время
        loadingCounters: 'Loading counterparties',
        loadingCounter: 'Loading counterparty',
        loadingEvents: 'Loading events',
        counterparty: 'Counterparty',
        author: 'Author',
        contacts: 'Contacts',
        jobTitle: 'Job title',
        placement: 'Place',
        employee: 'Contact person',
        delete: 'Delete',
        completeEvent: 'Complete event',
        finishEditing: 'Complete editing',
        nameEvent: 'Name Event',
        meetingStatus: 'Meeting status',
        meetingCanceled: 'Canceled',
        meetingCompleted: 'Completed',
        meetingDirected: 'Directed',
        meetingDeclined: 'Declined',
        meetingFetching: 'Loading meeting',
        initiator: 'Initiator',
        company: 'Company',
        matchmaker: 'Matchmaker',
        placementMeeting: 'Meeting placement',
        timeMeeting: 'Meeting time',
        dateMeeting: 'Meeting date',
        requestsMeeting: 'Requests meeting',
        serverError: 'Server error: ',
        serverErrorCode: 'Server error: ',
        welcome: 'Welcome,!',
        changesSaved: 'Changes saved',
        error: 'Error: ',
        requestError: 'Request error: ',
        loadingInfo: 'Loading information...',
        enterValidPhone: 'Please enter a valid phone number',
        sessionExpired: 'Session has expired, please log in again',
        enterFourDigitCode: 'Enter the four-digit code sent to the number',
        sendAgain: 'Send again',
        seconds: 'sec',
        invalidCode: 'Invalid code',
        clearInputFields: 'Clear input fields',
        loginInstructions: 'To log into the application, enter your login and password, or authorize using your phone number',
        sendConfirmationCode: 'Send confirmation code',
        or: 'OR',
        notAuthorized: 'You are not authorized',
        loginOrEmail: 'Login or email',
        password: 'Password',
        signIn: 'Sign in',
        requiredField: "Required field",
        createEventError: "Error creating event",
        confirmClose: "Close without saving?",
        meetingOf: "Meeting of",
        meetingAnd: "and",
        today: "Today",
        tomorrow: "Tomorrow",
        noAvailableSlots: "No available slots for booking",
        locationNotSpecified: "Location not specified",
        selectTimeAndPlace: "Select meeting time and location",
        noMeetsFound: "No meetings found",
        actions: "Actions",
        wantDeleteEvent: "Are you sure you want to delete this event?",
        endEventStatus: "Are you sure you want to end the event with the status ",
        sureAction: "Are you confident in your action?",
        complete: "Complete",
        confirmationAction: "Confirmation of action",
        confirm: "Confirm",
        nothingFound: "Nothing found",
        dataLoaded: "All data loaded",
        selectSegments: "Select agricultural sectors",
        selectIndustries: "Select area activity",
        selectManager: "Select manager",
        selectAdministrator: "Select administrator",
    },
    ru: {
        save: "Сохранить",
        selectLanguage: "Выберите язык",
        eventTickets: "Билеты на мероприятие",
        visitAsiaExpo: "Посещение ASIAEXPO 2025",
        ticketOnePerson: "Билет для одного человека на посещение конгресса в Олимпийском парке Сириус-арена",
        organizer: "Органайзер",
        visitor: "ПОСЕТИТЕЛЬ",
        promo: "Промо",
        media: "СМИ",
        speaker: "Спикер",
        exhibitor: "Экспонент",
        endOfList: "Конец списка",
        tickets: "Билеты",
        users: "Посетители",
        accessRights: "Доступы",
        menu: "Меню",
        search: "Поиск",
        searchPlaceholder: "Введите поисковой запрос",
        entrance: "Вход",
        shareApp: "Поделиться приложением",
        logOut: "Выйти из учетной записи",
        ticketing: "Оформление заказа",
        personalData: "Персональные данные",
        name: "Имя",
        required: "Обязательно для заполнения",
        surname: "Фамилия",
        organizationName: "Наименование организации",
        position: "Кем являетесь / Должность",
        notSpecified: "Не задан",
        mobilePhone: "Мобильный телефон",
        email: "Электронная почта",
        confirmOrder: "Подтвердить заказ",
        readyForAccreditation: "Готов для аккредитации",
        moreDetailed: "Подробнее",
        awaitingPayment: "В ожидании оплаты",
        accreditedBadgeIssued: "Аккредитован, бейдж выдан",
        issueBadge: "Выдать бейдж",
        change: "Изменить",
        repeatOrder: "Повторить заказ",
        orderCost: "Стоимость заказа",
        scanning: "Сканирование",
        myLocation: "Моя локация",
        location:"Местоположение",
        scanBadge: "Отсканируйте бейдж",
        hoverQrCode: "Наведите на QR-код для считывания",
        requestPermission: "Запросить разрешение",
        accuracy:"Точность",
        stopScanning: "Остановить сканирование",
        chooseEventLocation: "Выберите событие и вашу локацию",
        cancel: "Отмена",
        startingRegistration: "Начинаем оформление",
        creatingOrder: "Создаем заказ",
        orderCreated: "Заказ успешно создан",
        choosePaymentMethod: "Выбрать способ оплаты",
        promoCode: "Промокод",
        apply: "Применить",
        accountDetailsOrQrCode: "по реквизитам счета или QR-кодом, счет отправим после создания заказа по эл. почте",
        bankPagePayment: "на странице банка картой или через QR-код",
        onlinePayment: "Оплата онлайн",
        usedCashPayment: "Оплата б/нал на банковский счет",
        back: "Назад",
        agents: "Контрагенты",
        events: 'События',
        createBtn: "Создать",
        filter: 'Фильтр',
        country: 'Страна',
        segments: 'Отрасли',
        areaActivity: 'Направление деятельности',
        nameTable: 'Наименование',
        counterStatus: 'Статус контрагента',
        exhibition: 'Мероприятие',
        eventStatus: 'Статус события',
        eventOutcome: 'Исход события',
        lastEvent: 'Дата последнего события',
        creatingCounter: 'Создание контрагента',
        legalEntity: 'Юр.лицо',
        naturalPerson: 'Физ.лицо',
        contactInformation: 'Контактная информация', // Contact information
        segmentation: 'Сегментация', // Segmentation
        edit: 'Редактировать', // Edit
        createEvent: 'Создать событие', // Create event
        ogrn: 'ОГРН', // OGRN
        inn: 'ИНН', // INN
        kpp: 'КПП', // KPP
        supervisorFullName: 'ФИО Руководителя', // Supervisor's full name
        firstName: 'Имя', // First name
        lastName: 'Фамилия', // Last name
        phone: 'Телефон', // Phone
        region: 'Регион', // Region
        locality: 'Населенный пункт', // Locality
        postalCode: 'Индекс', // Postal code
        address: 'Адрес', // Address
        additionalAddressInfo: 'Дополнительная информация по адресу', // Additional address information
        description: 'Описание',
        contactPerson: 'Контактное лицо', // Contact person
        website: 'Сайт', // Website
        socialNetworks: 'Соц-сети', // Social networks
        activityDirection: 'Направление деятельности', // Activity direction
        manager: 'Менеджер', // Manager
        agriculturalSector: 'Отрасль СХ', // Agricultural sector
        administrator: 'Администратор', // Administrator
        start: 'Начало', // Start
        duration: 'Длительность', // Duration
        person: 'Человек', // Person
        eventType: 'Способ связи', // Event type
        meetingPlace: 'Место встречи', // Meeting place
        additionalInformation: 'Дополнительная информация', // Additional information
        create: 'Создать', // Create
        dateAndTime: 'Дата и время', // Date and time
        status: 'Состояние', // Status
        content: 'Содержание', // Content
        loading: 'Загрузка...', // Loading...
        date: 'Дата', // Date
        time: 'Время', // Time
        loadingCounters: 'Загрузка контрагентов',
        loadingCounter: 'Загрузка контрагента',
        loadingEvents: 'Загрузка событий',
        counterparty: 'Контрагент',
        author: 'Автор',
        contacts: 'Контакты',
        jobTitle: 'Должность',
        placement: 'Место',
        employee: 'Контактируемое лицо',
        delete: 'Удалить',
        completeEvent: 'Завершить событие',
        aboutCounterparty: 'О контрагенте',
        finishEditing: 'Завершите редактирование блока',
        nameEvent: 'Наименование события',
        meetingStatus: 'Статус встречи',
        meetingCanceled: 'Отменена',
        meetingCompleted: 'Завершена',
        meetingDirected: 'Направлена',
        meetingDeclined: 'Отклонена',
        meetingFetching: 'Загрузка встреч',
        initiator: 'Инициатор',
        company: 'Компания',
        matchmaker: 'Мэтчмейкер',
        placementMeeting: 'Место встречи',
        timeMeeting: 'Время встречи',
        dateMeeting: 'Дата встречи',
        requestsMeeting: 'Запросы на встречу',
        serverError: 'Ошибка сервера: ',
        requestError: 'Ошибка запроса: ',
        serverErrorCode: 'Ошибка сервера: ',
        welcome: 'Добро пожаловать, ',
        changesSaved: 'Изменения сохранены',
        error: 'Ошибка: ',
        loadingInfo: 'Загружаем информацию...',
        enterValidPhone: 'Пожалуйста, введите корректный номер телефона',
        sessionExpired: 'Время сессии истекло, авторизуйтесь повторно',
        enterFourDigitCode: 'Введите четырехзначный код отправленный на номер',
        sendAgain: 'Отправить повторно',
        seconds: 'сек',
        invalidCode: 'Неверный код',
        clearInputFields: 'Очистить поля ввода',
        loginInstructions: 'Для входа в приложение введите свой логин и пароль, или авторизуйтесь, используя номер телефона',
        sendConfirmationCode: 'Отправить код подтверждения',
        or: 'ИЛИ',
        notAuthorized: 'Вы не авторизованы',
        loginOrEmail: 'Логин или почта',
        password: 'Пароль',
        signIn: 'Войти',
        requiredField: "Обязательное поле",
        createEventError: "Ошибка при создании события",
        confirmClose: "Закрыть без сохранения?",
        meetingOf: "Встреча",
        meetingAnd: "с",
        today: "Сегодня",
        tomorrow: "Завтра",
        noAvailableSlots: "Нет доступных слотов для записи",
        locationNotSpecified: "Место не указано",
        selectTimeAndPlace: "Выберите время и место встречи",
        noMeetsFound: "Встречи не найдены",
        actions: "Действия",
        wantDeleteEvent: "Вы действительно хотите удалить это событие?",
        endEventStatus: "Вы действительно хотите завершить событие со статусом",
        sureAction: "Вы уверены в своем действии?",
        complete: "Завершить",
        confirmationAction: "Подтверждение действия",
        confirm: "Подтвердить",
        nothingFound: "Ничего не найдено",
        dataLoaded: "Все данный загружены",
        selectSegments: "Выберите сельскохозяйственные отрасли",
        selectIndustries: "Выберите направления деятельности",
        selectManager: "Выберите менеджера",
        selectAdministrator: "Выберите администратора",
    },
    ar: {
        save: "حفظ",
        selectLanguage: "اختر لغة",
        eventTickets: "تذاكر الحدث",
        visitAsiaExpo: "زيارة آسياكسبو 2025",
        ticketOnePerson: "تذكرة لشخص واحد لحضور مؤتمر حديقة سيريوس أرينا الأولمبية",
        organizer: "المنظم",
        visitor: "الزائر",
        promo: "شركة إعلانات",
        media: "وسائل الإعلام",
        speaker: "المتحدث",
        exhibitor: "مشارك في المعرض",
        endOfList: "نهاية القائمة",
        tickets: "التذاكر",
        users: "الزوار",
        accessRights: "مرور",
        menu: "شريط القوائم",
        search: "بحث",
        entrance: "مدخل",
        shareApp: "مشاركة التطبيق",
        logOut: "تسجيل الخروج من حسابك",
        ticketing: "تسجيل الطلب",
        personalData: "البيانات الشخصية",
        name: "الاسم",
        required: "مطلوب لملء",
        surname: "اللقب",
        organizationName: "اسم المنظمة",
        position: "من أنت / المنصب",
        notSpecified: "غير محدد",
        mobilePhone: "الهاتف المحمول",
        email: "البريد الإلكتروني",
        confirmOrder: "تأكيد الطلب",
        readyForAccreditation: "على استعداد لإصدار شارة",
        moreDetailed: "أكثر تفصيلا",
        awaitingPayment: "في انتظار الدفع",
        accreditedBadgeIssued: "معتمد ، شارة صادرة",
        issueBadge: "إصدار شارة",
        change: "لتغيير",
        repeatOrder: "تكرار الحجز",
        orderCost: "تكلفة الطلب",
        scanning: "المسح الضوئي",
        myLocation: "موقعي",
        location:"الموقع",
        scanBadge: "مسح الشارة",
        hoverQrCode: "مرر مؤشر الماوس فوق رمز الاستجابة السريعة لقراءته",
        requestPermission: "طلب الإذن",
        accuracy:"الدقة",
        stopScanning: "توقف عن المسح",
        chooseEventLocation: "اختيار الحدث والموقع الخاص بك",
        startingRegistration: "بدء التسجيل",
        cancel: "الإلغاء",
        creatingOrder: "إنشاء أمر",
        orderCreated: "تم إنشاء الطلب بنجاح",
        choosePaymentMethod: "اختر طريقة الدفع",
        promoCode: "الرمز الترويجي",
        apply: "استخدام",
        accountDetailsOrQrCode: "وفقا لتفاصيل الحساب أو رمز الاستجابة السريعة ، سوف نرسل الفاتورة عن طريق البريد الإلكتروني بعد إنشاء الطلب.",
        bankPagePayment: "على صفحة البنك عن طريق البطاقة أو باستخدام رمز الاستجابة السريعة",
        onlinePayment: "الدفع عبر الإنترنت",
        usedCashPayment: "الدفع غير النقدي إلى حساب مصرفي",
        back: "للعودة"
    },
};

export default translations;